var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "32px",
    height: "32px",
    viewBox: "0 0 80.000000 80.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,80.000000) scale(0.100000,-0.100000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M90 778 c-86 -45 -85 -39 -85 -377 l0 -298 29 -37 c42 -56 76 -66 219 -66 101 0 127 3 138 16 9 11 10 20 2 32 -8 14 -33 18 -142 22 -130 5 -133 6 -157 33 l-24 28 0 270 0 271 29 29 29 29 272 0 272 0 29 -29 c29 -29 29 -30 29 -154 0 -101 3 -127 16 -138 11 -9 20 -10 32 -2 15 9 17 30 17 150 0 138 0 140 -29 177 -48 63 -63 66 -364 66 -258 0 -269 -1 -312 -22z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297 533 c-29 -7 -37 -46 -37 -178 0 -148 8 -175 49 -175 41 0 51 23 51 117 l0 78 148 -148 c132 -132 152 -148 178 -145 24 2 30 8 32 32 3 26 -13 46 -145 178 l-148 148 78 0 c94 0 117 10 117 51 0 22 -6 32 -26 39 -25 10 -262 12 -297 3z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExit);
export default __webpack_public_path__ + "static/media/exit.ea035e513347644986d54e71e8114ac9.svg";
export { ForwardRef as ReactComponent };